var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button-upload"},[_c('button-icon-circle',{staticClass:"button-upload__button",attrs:{"type":"upload"},on:{"click":_vm.onClickButton}},[_vm._t("iconLabel")],2),_c('input',{ref:"uploder",staticClass:"button-upload__uploder",attrs:{"type":"file"},on:{"change":_vm.onFileSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }